import { Loader2 } from 'lucide-react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export default function Spinner({ size = 'md', className = '' }: SpinnerProps) {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  };

  return (
    <div className="flex items-center justify-center">
      <Loader2 className={`animate-spin text-primary-500 ${sizes[size]} ${className}`} />
    </div>
  );
}

export interface SpinnerOverlayProps {
  message?: string;
}

export function SpinnerOverlay({ message }: SpinnerOverlayProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 shadow-xl flex flex-col items-center gap-4">
        <Spinner size="lg" />
        {message && <p className="text-neutral-700 text-sm">{message}</p>}
      </div>
    </div>
  );
}
